import { render, staticRenderFns } from "./EventCommentsModal.vue?vue&type=template&id=43ceddac&scoped=true&"
import script from "./EventCommentsModal.vue?vue&type=script&lang=js&"
export * from "./EventCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./EventCommentsModal.vue?vue&type=style&index=0&id=43ceddac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ceddac",
  null
  
)

export default component.exports